import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-86904bea")

_pushScopeId("data-v-86904bea")
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "relative flex mr-2" }
const _hoisted_4 = { class: "absolute centered-element cursor-pointer" }
const _hoisted_5 = {
  key: 0,
  class: "text-red-lp-1000"
}
const _hoisted_6 = {
  key: 1,
  class: "text-gray-lp-500"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imageTemps, (img, index) => {
        return (_openBlock(), _createBlock("div", { key: index }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: img,
              class: "h-24 w-24 object-cover rounded my-2",
              alt: "result-image"
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Icons, {
                onClick: ($event: any) => (_ctx.removeImg(index)),
                name: "white-trash",
                class: "w-5 text-white"
              }, null, 8, ["onClick"])
            ])
          ])
        ]))
      }), 128)),
      (_ctx.imageTemps.length < _ctx.maxUpload)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.file.click())),
            onDragover: _cache[2] || (_cache[2] = e => _ctx.setDragAndDrop(e, true)),
            onDragleave: _cache[3] || (_cache[3] = e => _ctx.setDragAndDrop(e, false)),
            onDrop: _cache[4] || (_cache[4] = e => _ctx.onSubmitDrag(e)),
            class: 
          `flex justify-center cursor-pointer items-center text-12px border-2 border-dashed rounded-lg my-2 p-8 ${
            _ctx.isDragFile
              ? 'border-gray-lp-600 bg-gray-lp-100'
              : _ctx.isDataValidate
              ? 'border-red-lp-1000'
              : 'border-gray-lp-400'
          }`
        
          }, [
            _createVNode(_component_Icons, {
              class: !_ctx.isDataValidate ? 'text-gray-lp-600' : 'text-red-lp-1000',
              name: "grey-plus"
            }, null, 8, ["class"])
          ], 34))
        : _createCommentVNode("", true)
    ]),
    _createVNode("input", {
      type: "file",
      ref: "file",
      onChange: _cache[5] || (_cache[5] = e => (_ctx.isDragFile ? _ctx.onSubmitDrag(e) : _ctx.onSubmitClick(e))),
      accept: `image/png, image/jpeg`,
      class: "hidden",
      multiple: ""
    }, null, 544),
    (_ctx.isDataValidate)
      ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.captionError), 1))
      : (_openBlock(), _createBlock("p", _hoisted_6, " Maks. size: 2 MB, Maks. foto: 5 Foto, Format: .png, .jpg, .jpeg. "))
  ]))
})